export const SEND_EMAIL_CONFIRMATION_MUTATION = `
  mutation SendEmailConfirmationMutation {
    me {
      requestEmailConfirmationEmail
    }
  }
`;
